import { EVENT_CLOSE_CS_COMPENSATION_DIALOG, EVENT_OPEN_CS_COMPENSATION_DIALOG } from "./constants";

export interface CompensationItem {
  id: string | number;
  message: string;
  amount: string;
  title: string;
  key: string;
}

export interface CSCompensationDialogOption {
  onClaim?: (item: CompensationItem) => Promise<void> | void;
}

export const openCSCompensationDialog = (options: CSCompensationDialogOption = {}) => {
  const event = new CustomEvent(EVENT_OPEN_CS_COMPENSATION_DIALOG, {
    detail: options,
  });
  window.dispatchEvent(event);
};

export const closeCSCompensationDialog = () => {
  const event = new CustomEvent(EVENT_CLOSE_CS_COMPENSATION_DIALOG);
  window.dispatchEvent(event);
};
